<template>
  <h1 class="PageTitle text-3xl lg:text-4xl xl:text-6xl font-bold max-w-2xl">
    <slot />
  </h1>
</template>
